import React from 'react';

const inputName = (name, groupName) => (
  groupName && groupName !== '' ? `${groupName}[${name}]` : name
);

const CheckboxInput = props => (
  <input
    type="checkbox"
    id={props.inputId}
    name={inputName(props.name, props.groupName)}
    value={props.value}
    onChange={props.onChange}
    checked={props.checked}
    defaultChecked={props.defaultChecked}
    className={props.inputClassName} />
);

CheckboxInput.defaultProps = {
  groupName: 'parameters',
  name     : '',
  checked  : false,
};

export default CheckboxInput;
